import InitiativeItems from "../../../components/initiatives/Initiatives-items";
import Form from "../../../components/form/Form";
import InitiativeContainer from "../../../components/initiatives/Initiatives-container";
import {
  updateInitiative,
  getInitiatives,
  deleteInitiative,
} from "../../../apis/initiativesApi";
import Error from "../../../components/errors-messages/Error";

import React from "react";
import { useState, useEffect } from "react";

function Initiatives(props) {
  const [state, setState] = useState({
    isEditing: false,
    initiatives: [],
    editInitiative: null,
    editLoading: false,
    error: null,
  });

  useEffect(() => {
    loadPosts();
    // const socket = openSocket("https://shark-app-2ttko.ondigitalocean.app/website");

    // socket.on("posts", (data) => {
    //   if (data.action === "create") {
    //     addPost(data.post);
    //   } else if (data.action === "update") {
    //     updatePost(data.post);
    //   } else if (data.action === "delete") {
    //     loadPosts();
    //   }
    // });
  }, []);

  const loadPosts = async () => {
    const { data, error } = await getInitiatives();
    if (!data && error) {
      return setState((prevState) => {
        return {
          isEditing: false,
          initiatives: [],
          editInitiative: null,
          editLoading: false,
          error: error,
        };
      });
    }
    setState((prevState) => {
      return {
        ...prevState,
        initiatives: data.initiatives,
      };
    });
  };

  const startEditPostHandler = (postId) => {
    setState((prevState) => {
      const loadedInitiative = {
        ...prevState.initiatives.find((p) => p._id === postId),
      };
      return {
        ...prevState,
        isEditing: true,
        editInitiative: loadedInitiative,
      };
    });
  };

  const cancelEditHandler = () => {
    setState((prevState) => {
      return {
        ...prevState,
        isEditing: false,
        editInitiative: null,
        error: null,
      };
    });
  };

  const finishEditHandler = async (initiativeData) => {
    setState((prevState) => {
      return {
        ...prevState,
        editLoading: true,
      };
    });

    // const formData = new FormData();

    // formData.append("initiativeName", postData.initiativeName);
    // formData.append("content", postData.content);
    // formData.append("image", postData.image);
    let initiativeId = state.editInitiative ? state.editInitiative._id : null;
    const { data, error } = await updateInitiative(
      props.token,
      initiativeId,
      initiativeData
    );
    if (!data && error) {
      return setState((prevState) => {
        return {
          ...prevState,
          isEditing: false,
          editInitiative: null,
          editLoading: false,
          error: error,
        };
      });
    }
    const initiative = {
      _id: data.initiative._id,
      name: data.initiative.name,
      description: data.initiative.description,
    };

    setState((prevState) => {
      let updatedInitiatives;
      if (prevState.editInitiative) {
        updatedInitiatives = prevState.initiatives.map((c) =>
          c._id === initiative._id ? initiative : c
        );
      } else {
        updatedInitiatives = prevState.initiatives.concat(initiative);
      }
      return {
        ...prevState,
        initiatives: updatedInitiatives,
        isEditing: false,
        editInitiative: null,
        editLoading: false,
      };
    });
  };

  const newPostHandler = () => {
    setState((prevState) => {
      return { ...prevState, isEditing: true };
    });
  };

  const deletePostHandler = async (postId) => {
    setState((prevState) => {
      return { ...prevState, postsLoading: true };
    });
    const { data, error } = await deleteInitiative(props.token, postId);
    if (!data && error) {
      return setState((prevState) => {
        return {
          ...prevState,
          isEditing: false,
          editInitiative: null,
          editLoading: false,
          error: error,
        };
      });
    }
    loadPosts();

    setState((prevState) => {
      return { ...prevState, postsLoading: false };
    });
  };

  return (
    <>
      <Error error={state.error} onHandle={cancelEditHandler} />
      <Form
        editing={state.isEditing}
        currentItem={state.editInitiative}
        page={"Initiative"}
        // loading={state.editLoading}
        onCancelEdit={cancelEditHandler}
        onFinishEdit={finishEditHandler}
      />
      <InitiativeContainer
        onAddInitiative={newPostHandler}
        isAuth={props.isAuth}
      >
        {state.initiatives.map((initiative) => (
          <InitiativeItems
            onStartEdit={startEditPostHandler.bind(this, initiative._id)}
            key={initiative._id}
            name={initiative.name}
            description={initiative.description}
            onDelete={deletePostHandler.bind(this, initiative._id)}
            isAuth={props.isAuth}
          />
        ))}
      </InitiativeContainer>
      ;
    </>
  );

  // props.isAuth && (
  //   <li className="navigation-item" key="logout">
  //     <button onClick={props.onLogout}>Logout</button>
  //   </li>
  // ),
}

export default Initiatives;
